import { useContext, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from './index.module.less';
import { Button, Flex, Modal } from 'antd';
import { observer } from 'mobx-react';
import { USER_TOKEN } from '@/stores/user';
import { userApi } from '@/axios/user';
import LogoIcon from '@/assets/icons/logo.svg?react';
import { RouteContext } from '@/routes/provider';

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { menuList } = useContext(RouteContext);
  // 路由变化时，卸载所有模态框
  useEffect(() => {
    return () => {
      Modal.destroyAll();
    };
  }, [location]);

  return (
    <div className={styles.layout}>
      <div className={styles.header}>
        <Flex
          align="center"
          gap={8}
          className={styles.logo}
          onClick={() => {
            navigate('/');
          }}
        >
          <LogoIcon />
          小冰科技
        </Flex>
        {menuList.map((menu) => (
          <div
            key={menu.key}
            className={`${styles.menuItem} ${location.pathname.startsWith(menu.key) ? styles.active : ''}`}
            onClick={() => {
              navigate(menu.key);
            }}
          >
            {menu.label}
          </div>
        ))}
        <Button
          style={{ marginLeft: 'auto', padding: '0 12px' }}
          onClick={() => {
            userApi.logout();
            localStorage.removeItem(USER_TOKEN);

            window.location.href = '/login';
          }}
        >
          退出登录
        </Button>
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default observer(Layout);
